import { Card, CardContent, CardHeader, CardTitle } from "./ui/Card";
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid, ResponsiveContainer } from "recharts";

interface SalesChartProps {
  data: {
    labels: string[];
    current: number[];
    previous: number[];
    totals: {
      current: number;
      previous: number;
    };
    period: {
      current: string;
      previous: string;
    };
  } | null;
}

export function SalesChart({ data }: SalesChartProps) {
  if (!data) return null;

  // Transforma os arrays em objetos para o Recharts
  const chartData = data.labels.map((label, index) => ({
    name: label,
    current: data.current[index] || 0,
    previous: data.previous[index] || 0,
  }));

  const totalCurrent = data.totals.current;
  const totalPrevious = data.totals.previous;

  return (
    <Card className="border border-gray-200 hover:shadow-md transition-shadow duration-200">
      <CardHeader>
        <CardTitle className="text-[#68686A] text-md font-bold">Gráfico de Vendas</CardTitle>
        <div className="flex flex-col sm:flex-row sm:space-x-6 text-sm text-[#68686A]">
          <span className="font-bold text-[#849D70]">
            Período atual ({data.period.current}): R$ {totalCurrent.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </span>
          <span className="font-bold text-[#D4C070]">
            Período anterior ({data.period.previous}): R$ {totalPrevious.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </span>
        </div>
      </CardHeader>
      <CardContent>
        <div className="h-80 w-full">
          <ResponsiveContainer width="100%" height="100%" minWidth={0}>
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#EEF1F2" />
              <XAxis
                dataKey="name"
                stroke="#68686A"
                fontSize={10}
                tick={{ fontSize: 10 }}
              />
              <YAxis
                stroke="#68686A"
                fontSize={10}
                tick={{ fontSize: 10 }}
              />
              <Tooltip
                cursor={{ stroke: '#68686A', strokeWidth: 1 }}
                contentStyle={{ backgroundColor: '#fff', border: '1px solid #68686A', fontSize: 12 }}
                formatter={(value: any) => `R$ ${Number(value || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`}
                labelFormatter={(label) => `Data: ${label}`}
              />
              <Legend
                verticalAlign="top"
                align="left"
                height={26}
                wrapperStyle={{ padding: '0 10px' }}
              />
              <Line
                type="monotone"
                dataKey="current"
                stroke="#849D70"
                strokeWidth={2}
                dot={{ fill: '#849D70', strokeWidth: 2, r: 4 }}
                activeDot={{ r: 6, fill: '#849D70' }}
                name="Período atual"
              />
              <Line
                type="monotone"
                dataKey="previous"
                stroke="#D4C070"
                strokeWidth={2}
                strokeDasharray="5 5"
                dot={{ fill: '#D4C070', strokeWidth: 2, r: 4 }}
                activeDot={{ r: 6, fill: '#D4C070' }}
                name="Período anterior"
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}